"use strict";
/**
 * @file Created on 02.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NChangedWinDate =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedWinDate, _NotificationDoc_1$No);

  /**
   * @param windowId
   * @param newDateFrom
   * @param newDateTo
   * @param oldDateFrom
   * @param oldDateTo
   */
  function NChangedWinDate(windowId, newDateFrom, newDateTo, oldDateFrom, oldDateTo) {
    var _this;

    _classCallCheck(this, NChangedWinDate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinDate).call(this));
    _this.windowId = windowId;
    _this.newDateFrom = newDateFrom;
    _this.newDateTo = newDateTo;
    _this.oldDateFrom = oldDateFrom;
    _this.oldDateTo = oldDateTo;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedWinDate, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedWinDate(mat.windowId, mat.newDateFrom, mat.newDateTo, mat.oldDateFrom, mat.oldDateTo);
    }
  }]);

  return NChangedWinDate;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedWinDate = NChangedWinDate;

NChangedWinDate.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedWinDate.name);
  return {
    windowId: builder.id('windowId'),
    newDateFrom: builder.date('newDateFrom'),
    newDateTo: builder.date('newDateTo'),
    oldDateFrom: builder.date('oldDateFrom'),
    oldDateTo: builder.date('oldDateTo')
  };
}();